import { render, staticRenderFns } from "./block-progress.vue?vue&type=template&id=30304307"
import script from "./block-progress.vue?vue&type=script&lang=js"
export * from "./block-progress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports